import { h } from "preact";

import ItemStack from "../../ItemStack";
import BarrelCard, { BarrelCardProps } from "../BarrelCard";

import styles from "./BarrelCardMirror.module.css";

interface Props extends BarrelCardProps {
    numberOfItems: number;
}

function BarrelCardMirrorContent({ ...barrelCardProps }: Omit<Props, "numberOfItems">) {
    return (
        <div class={styles.barrelCardMirror}>
            <BarrelCard {...barrelCardProps} showActionButtons={false}/>
        </div>
    );
}

function BarrelCardMirror({
    numberOfItems,
    ...barrelCardProps
}: Props) {
    return (
        <ItemStack numberOfItems={numberOfItems}>
            <BarrelCardMirrorContent {...barrelCardProps}/>
        </ItemStack>
    );
}

export default BarrelCardMirror;
export { BarrelCardMirrorContent };
